module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/thumb/brc-global-en-09af519c1859ddb2789e1df4ba3570eb.jpg";